import { render, staticRenderFns } from "./ResearchViolinPlot.vue?vue&type=template&id=ffd8e8ec&scoped=true&"
import script from "./ResearchViolinPlot.vue?vue&type=script&lang=js&"
export * from "./ResearchViolinPlot.vue?vue&type=script&lang=js&"
import style0 from "./ResearchViolinPlot.vue?vue&type=style&index=0&id=ffd8e8ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffd8e8ec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/Portal (Dev)/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ffd8e8ec')) {
      api.createRecord('ffd8e8ec', component.options)
    } else {
      api.reload('ffd8e8ec', component.options)
    }
    module.hot.accept("./ResearchViolinPlot.vue?vue&type=template&id=ffd8e8ec&scoped=true&", function () {
      api.rerender('ffd8e8ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/singleCellBrowser/ResearchViolinPlot.vue"
export default component.exports